module.exports = __webpack_public_path__ + "media/sales_analysis.e9593ec1.mp4";